<template>
  <div id="app" class="novo-cadastro">
    <div class="header">
      <BackBar></BackBar>
    </div>
    <h2 v-if="passo === 1">Solicitar carteira de pesca</h2>
    <h2 v-if="passo === 2">Resumo do cadastro</h2>
    <el-card class="main-card">
      <template v-if="passo === 1">
        <div class="section title">
          <h3>Identificação</h3>
        </div>
        <div class="section double-column">
          <div class="info2">
            <h4><strong>Dados pessoais</strong></h4>
            <p>
              Nome: <strong>{{ solicitante.nome }}</strong>
            </p>
            <p>
              CPF:
              <strong>{{
                formatarDocumento(solicitante.cpf || solicitante.passaporte)
              }}</strong>
            </p>
            <p>
              Sexo:
              <strong>{{
                solicitante.sexo === 0 ? "Masculino" : "Feminino"
              }}</strong>
            </p>
            <p>
              Data de nascimento:
              <strong>{{ solicitante.dataNascimentoString }}</strong>
            </p>
          </div>
          <div class="info2" v-if="!solicitante.estrangeiro">
            <h4><strong>Endereço principal</strong></h4>
            <p>
              CEP:
              <strong>{{
                formatarCEP(solicitante.enderecoPrincipal.cep)
              }}</strong>
            </p>
            <p>
              Logradouro:
              <strong>{{ solicitante.enderecoPrincipal.logradouro }}</strong>
            </p>
            <p>
              Bairro:
              <strong>{{ solicitante.enderecoPrincipal.bairro }}</strong>
            </p>
            <p>
              Município:
              <strong>{{
                solicitante.enderecoPrincipal.municipio &&
                  solicitante.enderecoPrincipal.municipio.nome
              }}</strong>
            </p>
            <p>
              UF:
              <strong>{{
                solicitante.enderecoPrincipal.municipio &&
                  solicitante.enderecoPrincipal.municipio.estado.nome
              }}</strong>
            </p>
          </div>

          <div class="info2" v-if="solicitante.estrangeiro">
            <h4><strong>Endereço estrangeiro</strong></h4>
            <p>
              ZIP/Postal Code:
              <strong>{{
                formatarCEP(solicitante.enderecoPrincipal.cep)
              }}</strong>
            </p>
            <p>
              Country:
              <strong>{{
                solicitante.enderecoPrincipal.pais &&
                  solicitante.enderecoPrincipal.pais.nome
              }}</strong>
            </p>
            <p>
              City:
              <strong>{{
                solicitante.enderecoPrincipal.municipioPassport
              }}</strong>
            </p>
            <p>
              State/Province/Region:
              <strong>{{
                solicitante.enderecoPrincipal.estadoPassport
              }}</strong>
            </p>
            <p>
              Address Line 1:
              <strong>{{ solicitante.enderecoPrincipal.logradouro }}</strong>
            </p>
            <p>
              Adress Line 2:
              <strong>{{ solicitante.enderecoPrincipal.complemento }}</strong>
            </p>
          </div>
        </div>

        <div class="section title">
          <h3>Informações complementares</h3>
        </div>
        <InformacoesComplementares
          :modelValue="informacoesComplementares"
          :listaOpcoes="listaOpcoes"
          @update:modelValue="val => (informacoesComplementares = val)"
          :verificaCampoErro="verificaCampoErro"
          :validarPasso1="validarPasso1"
        />
        <div class="actions">
          <el-button class="green-border" @click="goBack">Cancelar</el-button>
          <el-button type="primary" @click="irParaResumo">Ver Resumo</el-button>
        </div>
      </template>

      <template v-else-if="passo === 2">
        <ResumoCadastro
          :solicitante="solicitante"
          :informacoesComplementares="informacoesComplementares"
          :listaOpcoes="listaOpcoes"
          @voltar="voltarParaFormulario"
          @confirmar="confirmar"
        />
      </template>
    </el-card>
  </div>
</template>

<script>
import ResumoCadastro from "../resumo/ResumoCadastro.vue";
import InformacoesComplementares from "../informacoes/InformacoesComplementares.vue";
import { REGISTRAR } from "../../store/actions.type.js";
import {
  MATERIAL_PESCA_MOCK,
  PEIXE_MAIS_PESCADO,
  MODALIDADE_PESCA_MOCK,
  TIPO_ISCA_MOCK // Importação do mock de tipos de isca
} from "../../utils/layout/mockData.js"; // Importação da lista de materiais
import BackBar from "../layouts/BackBar.vue";
import {
  formatarDocumento,
  formatarCEP
} from "../../utils/layout/mascarasFormat.js";

export default {
  name: "NovoCadastro",
  components: {
    BackBar,
    ResumoCadastro,
    InformacoesComplementares
  },
  data() {
    return {
      passo: 1,
      validarPasso1: false,
      solicitante: {
        estrangeiro: JSON.parse(localStorage.getItem("pessoa")).estrangeiro,
        nome: JSON.parse(localStorage.getItem("pessoa")).nome, // Usando diretamente solicitanteLocalStorage.nome
        cpf: JSON.parse(localStorage.getItem("pessoa")).cpf,
        passaporte: JSON.parse(localStorage.getItem("pessoa")).passaporte,
        dataNascimento: JSON.parse(localStorage.getItem("pessoa"))
          .dataNascimento,
        dataNascimentoString: new Date(
          JSON.parse(localStorage.getItem("pessoa")).dataNascimento
        ).toLocaleDateString(),
        sexo: JSON.parse(localStorage.getItem("pessoa")).sexo.codigo,
        nomeMae: JSON.parse(localStorage.getItem("pessoa")).nomeMae,
        email: JSON.parse(localStorage.getItem("pessoa")).email,
        enderecoPrincipal: this.tratarEndereco(
          JSON.parse(localStorage.getItem("pessoa")).enderecos[0]
        ),
        enderecoCorrespondencia: this.tratarEndereco(
          JSON.parse(localStorage.getItem("pessoa")).enderecos[0]
        ),
        enderecoEstrangeiro: {
          nacionalidade: null,
          descricaoEndereco: null,
          cidade: null,
          estado: null,
          pais: null
        }
      },
      informacoesComplementares: {
        modalidadePesca: 0,
        localizacaoPreferencialPesca: 0,
        rendaMensal: 0,
        diasPescaPorAno: 0,
        gastoMedioPesca: 0,
        localPesca: 0,
        materialPesca: 0,
        tipoIsca: 0,
        agenciaTurismo: 0,
        peixeMaisPescado: null,
        equipamentos: []
      },
      expandedItems: ["1", "2"],
      listaOpcoes: {
        equipamentos: MATERIAL_PESCA_MOCK,
        peixesMaisPescados: PEIXE_MAIS_PESCADO,
        modalidadesPesca: MODALIDADE_PESCA_MOCK,
        tiposIsca: TIPO_ISCA_MOCK // Adicionando os tipos de isca
      }
    };
  },
  methods: {
    goBack() {
      this.$router.go(-1); // Navigate back to the previous page
    },
    verificaCampoErro(campo) {
      if (campo === "diasPescaPorAno") {
        if (this.informacoesComplementares.diasPescaPorAno <= 0) {
          return true;
        }
      } else if (campo === "peixesMaisPescados") {
        if (this.informacoesComplementares.peixeMaisPescado.length === 0) {
          return true;
        }
      } else if (campo === "equipamentos") {
        if (
          !this.informacoesComplementares.equipamentos ||
          this.informacoesComplementares.equipamentos.length === 0
        ) {
          return true;
        }
      }
      return false;
    },
    validarEtapa() {
      if (
        this.verificaCampoErro("diasPescaPorAno") ||
        this.verificaCampoErro("peixesMaisPescados") ||
        this.verificaCampoErro("equipamentos")
      ) {
        window.scrollTo(0, 0);
        const h = this.$createElement;
        this.$notify({
          title: "Erro",
          message: h(
            "i",
            { style: "color: #295661" },
            "Verifique os campos obrigatórios."
          )
        });
        return false;
      }
      return true;
    },
    irParaResumo() {
      this.validarPasso1 = true;
      if (this.validarEtapa()) {
        this.validarPasso1 = false;
        this.passo = 2;
      }
    },
    voltarParaFormulario() {
      this.passo = 1;
    },
    confirmar() {
      this.$confirm(
        "Declaro, para os devidos fins e efeitos legais, serem solicitanteis e verdadeiras as informações inseridas na solicitação da carteira de pesca ao IPAAM, sobre as quais assumo todas as responsabilidades, sob pena de incorrer nas sanções previstas nos artigos 299 e 307 do Código Penal (falsidade ideológica e falsa identidade).",
        "Confirmação",
        {
          confirmButtonText: "Confirmar",
          cancelButtonText: "Cancelar",
          cancelButtonClass: "green-border"
        }
      )
        .then(() => {
          let registro = {
            solicitante: this.solicitante,
            informacoesComplementares: this.informacoesComplementares
          };

          this.$store.dispatch(REGISTRAR, registro).then(p => {
            if (p) {
              this.$router.push({
                name: "home"
              });
            }
          });
        })
        .catch(() => {});
    },
    tratarEndereco(endereco) {
      return {
        ...endereco,
        tipo: endereco.tipo.id,
        zonaLocalizacao: endereco.zonaLocalizacao.codigo
      };
    },
    formatarDocumento,
    formatarCEP
  }
};
</script>

<style>
/* Estilo geral */
#app {
  font-family: "Nunito", sans-serif;
  background-color: #f0f4f8;
  color: #333;
}

h2,
h3 {
  color: #295661;
}

h2 {
  font-family: Nunito;
  font-size: 18px;
  font-style: normal;
  font-weight: 800;
  line-height: normal;
  margin: 15px 0 15px 0;
}

h3 {
  color: #295661;

  /* Título de páginas */
  font-family: Nunito;
  font-size: 18px;
  font-style: normal;
  font-weight: 800;
  line-height: normal;
}

.novo-cadastro h4 {
  color: #295661;
  font-family: "Nunito";
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin-top: 0;
}

.section.title {
  display: flex;
  gap: 10px;
  padding: 10px;
  border-bottom: 1px solid #ededed;
  border-radius: 0;
}

.main-card .el-card {
  padding: 0;
}

.main-card .el-card__body {
  padding: 16px;
}

h4 {
  font-family: Nunito;
  font-size: 16px;
  font-style: normal;
  font-weight: 800;
  line-height: normal;
  margin: 15px 0 20px 0;
  color: #295661;
}

/* Cabeçalho */
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #295661;
  padding: 10px 0px;
  border-radius: 8px;
}
.header button {
  color: #295661;
}

.search-bar {
  width: 300px;
  border-radius: 4px;
}

/* Cartão principal */
.el-card.main-card {
  padding: 10px;
  border-radius: 10px;
  background: #fff;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.1);
}

/* Seções */
.section {
  margin-bottom: 20px;
  padding: 10px;
  border-radius: 8px;
}

.section.title {
  margin-bottom: 0px;
}

.section p {
  margin-bottom: 10px;
}

.double-column {
  display: flex;
  flex-direction: row;
  gap: 10rem;
}

.info2 {
  margin: 10px 0;
}

.info2.padding {
  padding: 10px;
}

.section p {
  color: #414141;
  font-family: Nunito;
  font-size: 16px;
  line-height: normal;
}

.radio-group {
  margin-top: 2px;
}

.total-price {
  font-style: italic;
}

/* Grupos de entrada */
.radio-group,
.checkbox-group,
.select,
.input-number {
  margin-bottom: 15px;
}

/* Botões */
.actions {
  display: flex;
  justify-content: space-between;
  gap: 10px;
}

.el-button.green-border {
  border-radius: 20px;
  padding: 10px 40px !important;
}

.el-button--primary {
  background-color: #00c254;
  color: #fff;
  border-radius: 20px !important;
  font-size: 14px;
  padding: 10px 40px !important;
}

.info-box {
  background-color: #dde9ed !important; /* tom de azul claro */
  border-radius: 4px;
  padding: 10px 16px;
  width: 600px;
  float: right;
}

.info-content {
  display: flex;
  flex-direction: column;
}

.info-content .icon-atencao {
  display: flex;
  color: #295661;
  font-size: 16px;
  font-weight: 700;
  line-height: normal;
  margin-bottom: 7px;
}

.el-icon-info {
  font-size: 18px;
  color: #2c3e50;
  margin-right: 10px;
}

.info-text {
  display: flex;
  flex-wrap: wrap;
  font-style: italic;
  color: #2c3e50;
  font-size: 14px;
  font-weight: 300;
}

.separator {
  margin: 0 8px;
  color: #999;
}

/* Estilo do título do collapse */
.el-collapse-item__header {
  background-color: #ebf1f3 !important;
  padding: 8px 16px;
  font-size: 18px !important;
  color: #295661 !important;
  font-weight: 800 !important;
}

.el-radio__input.is-checked .el-radio__inner {
  background: #00c254 !important;
  border-color: #00c254 !important;
}

.el-radio .el-radio__label {
  color: #414141 !important;
  font-family: Nunito;
  font-size: 16px !important;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
}

.el-radio__input.is-checked + .el-radio__label {
  color: #414141 !important;
}

el-checkbox .el-checkbox__label {
  color: #414141;
  font-size: 16px;
  font-weight: 400;
}

.el-checkbox__input.is-checked .el-checkbox__inner {
  background-color: #00c254 !important;
  border-color: #00c254 !important;
}

.el-checkbox__input.is-checked + .el-checkbox__label {
  color: #414141 !important;
}

.icon-atencao {
  display: flex;
  align-items: center;
  gap: 10px;
  align-self: start;
}

@media (max-width: 768px) {
  .el-button + .el-button {
    margin-left: 0 !important;
  }
  #view-layout .main {
    width: 100%;
    padding: 0 5px;
  }

  .double-column {
    flex-direction: column;
    gap: 1rem;
  }

  .info-box {
    width: 100% !important;
    float: none;
  }

  .actions {
    flex-direction: column;
    gap: 10px;
  }

  .radio-group,
  .checkbox-group,
  .select,
  .input-number {
    width: 100%;
  }

  .novo-cadastro h2 {
    font-size: 16px;
    text-align: center;
  }

  .novo-cadastro h3 {
    font-size: 14px;
  }

  .novo-cadastro h4 {
    font-size: 14px;
  }

  .section {
    padding: 5px;
    margin-bottom: 10px;
  }

  .section p {
    font-size: 14px;
    line-height: 1.5;
  }

  .info2 {
    margin: 5px 0;
  }

  .el-card.main-card {
    padding: 5px;
  }

  .el-button.green-border,
  .el-button--primary {
    width: 100%;
    padding: 10px !important;
  }

  .el-message-box {
    width: unset !important;
  }
}
</style>
